import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WkTemplateDialogComponent } from '../dialogs/wk-template/wk-template.dialog';

@Injectable({
  providedIn: 'root',
})
export class WkCreateDialogService {
  constructor(private readonly matDialog: MatDialog) {}

  openCreateDialogTemplate() {
    this.matDialog.open(WkTemplateDialogComponent, {
      disableClose: true,
      autoFocus: false,
      width: '600px',
    });
  }
}
